import { z } from "zod/v4";

export const AnalyticsEventDtoSchema = z.object({
  id: z.uuid(),
  identifier: z.string(),
  name: z.string(),
  description: z.string().nullish(),
  eventCountLastDay: z.number().nullish(),
  lastEventTs: z.number().nullish(),
  error: z.string().nullish(),
});

export type AnalyticsEventDto = z.infer<typeof AnalyticsEventDtoSchema>;
